import type { ValidationMessage } from '../types/applicationApi.types';

const STEP_A_FIELDS = new Set([
  'firstName',
  'lastName',
  'preferredName',
  'email',
  'phone',
  'address',
  'city',
  'state',
  'zip',
  'language',
]);

const STEP_B_FIELDS = new Set(['isOver18', 'isAuthorizedToWork']);

const STEP_C_FIELDS = new Set([
  'licenses',
  'hasClassD',
  'classDNumber',
  'classDExpiration',
  'hasClassG',
  'classGNumber',
  'classGExpiration',
  'hasGuardCard',
  'guardCardNumber',
  'guardCardExpiration',
  'has8HourCert',
  'cert8HourDate',
  'has16HourCert',
  'cert16HourDate',
  'hasFirearmCreds',
  'firearmCredsNumber',
  'firearmCredsExpiration',
  'hasCprAed',
  'cprAedExpiration',
  'hasTwic',
  'twicExpiration',
]);

const STEP_D_FIELDS = new Set(['roles', 'locations', 'shifts', 'hasTransport', 'startDate']);

const STEP_E_FIELDS = new Set([
  'indoorOutdoorComfort',
  'standingPatrolTolerance',
  'languagesSpoken',
  'isVeteran',
  'eeoRace',
  'eeoGender',
  'eeoDisclosureConsent',
]);

const STEP_F_FIELDS = new Set([
  'consentPrivacy',
  'consentMessaging',
  'consentVideoRecording',
  'signature',
  'signatureDate',
]);

function fieldToKey(field: string): string {
  if (!field) return field;
  const segments = field.split('.');
  return segments[segments.length - 1] ?? field;
}

export function mapValidationMessages(messages: ValidationMessage[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const message of messages) {
    const key = fieldToKey(message.field);
    if (!Object.hasOwn(map, key)) {
      map[key] = message.message;
    }
  }
  return map;
}

export function getStepIndexForField(field: string): number | null {
  if (field.startsWith('florida.') || field.startsWith('newYork.') || field.startsWith('certifications.')) {
    return 2;
  }

  if (STEP_A_FIELDS.has(field)) return 0;
  if (STEP_B_FIELDS.has(field)) return 1;
  if (STEP_C_FIELDS.has(field)) return 2;
  if (STEP_D_FIELDS.has(field)) return 3;
  if (STEP_E_FIELDS.has(field)) return 4;
  if (STEP_F_FIELDS.has(field)) return 5;

  return null;
}

export function getFirstStepIndexForMessages(messages: ValidationMessage[]): number | null {
  for (const message of messages) {
    const step = getStepIndexForField(message.field);
    if (step !== null) {
      return step;
    }
  }
  return null;
}
